import { BrowserRouter } from "react-router-dom";
import UserRoutes from "../UserRoutes";
import PublicRoutes from "../PublicRoutes";
import { useContext, useState } from "react";
import AppLayout from "../../Components/AppLayout";
import AdminRoutes from "../AdminRoutes";
import { UserContext } from "../../App";

const AppRoutes = () => {
  let routesComponent;

  const { userData } = useContext(UserContext);

  switch (userData?.role) {
    case "user":
      routesComponent = (
        <AppLayout userName={userData?.name} userType={userData?.role} contents={<UserRoutes />} />
      );
      break;

    case "public":
      routesComponent = <PublicRoutes />;
      break;

    case "admin":
      routesComponent = (
        <AppLayout userName={userData?.name} userType={userData?.role} contents={<AdminRoutes />} />
      );
      break;
    default:
      routesComponent = <PublicRoutes />;
      break;
  }

  return <BrowserRouter>{routesComponent}</BrowserRouter>;
};

export default AppRoutes;
